import SuperRepository from '../superRepository'

export default new (class PlayersRepository extends SuperRepository {
  baseUri() {
    return 'player'
  }
  geoCountry = async() => this.httpClient().get(`${this.baseUri()}/geo_country`)
  promocode = async() => this.httpClient().get(`${this.baseUri()}/promocode`)
  synchronize = async (data, params) =>
    this.httpClient().post(`${this.baseUri()}/synchronize?${data}`, params)
  bulkUpdate = async ({params, ...data}) => {
    return this.httpClient().putQuery(`${this.baseUri()}/bulk_update`, data, params)
  }
  exportPlayersReportToken = (data, params) => this.reportHttpClient().postQuery('export/player/token', data, params)
})()
